import axios from "axios"
import useSWR from "swr"

// 250726 (fix): kirim Bearer token (sama seperti useResultSet). Tanpa header ini,
// backend tak bisa mengenali identitas user → EntityScope::applyOutletScope fail-open
// → catatan customer LINTAS-ENTITAS ikut tampil (user VISION melihat data ATALLA).
const fetcher = async (url, params) => {
    const access_token = localStorage.getItem('access_token') ?? ''
    return await axios
        .get(url, { params, headers: { Authorization: `Bearer ${access_token}` } })
        .then((res) => res.data.data)
}

const useCustomerNoteRepositories = (params) => {
    const { data, error, mutate, isValidating } = useSWR([`${process.env.REACT_APP_INVENTORY_API_URL}/customer-notes`, params], fetcher)

    return {
        data,
        isLoading: !error && !data,
        error,
        isValidating,
        mutate
    }
}

export default useCustomerNoteRepositories